import {
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
} from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  shiftRight2gqph14wydb8s as shiftRight,
  convertToInty04h231mmjoh as convertToInt,
  fromInt2ii0rejb1w62w as fromInt,
  shiftLeft3tsh2sstjchzn as shiftLeft,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Symbol17xuwzgi5g8ve as Symbol } from './Symbol.mjs';
import { atomicfu$AtomicRefArray$ofNulls2kz3j9ehigwa3 as atomicfu$AtomicRefArray$ofNulls } from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.common.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var LockFreeTaskQueueClass;
function LockFreeTaskQueue() {
  if (LockFreeTaskQueueClass === VOID) {
    class $ {
      constructor(singleConsumer) {
        this.u1i_1 = atomic$ref$1(new (LockFreeTaskQueueCore())(8, singleConsumer));
      }
      v2() {
        return this.u1i_1.kotlinx$atomicfu$value.v2();
      }
      x1i(element) {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.u1i_1;
        while (true) {
          var cur = this_0.kotlinx$atomicfu$value;
          switch (cur.x1i(element)) {
            case 0:
              return true;
            case 2:
              return false;
            case 1:
              this.u1i_1.atomicfu$compareAndSet(cur, cur.w1());
              break;
          }
        }
      }
      yj() {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.u1i_1;
        while (true) {
          var cur = this_0.kotlinx$atomicfu$value;
          var result = cur.yj();
          if (!(result === Companion_getInstance().q1j_1)) {
            return (result == null ? true : !(result == null)) ? result : THROW_CCE();
          }
          this.u1i_1.atomicfu$compareAndSet(cur, cur.w1());
        }
      }
    }
    initMetadataForClass($, 'LockFreeTaskQueue');
    LockFreeTaskQueueClass = $;
  }
  return LockFreeTaskQueueClass;
}
function fillPlaceholder($this, index, element) {
  var old = $this.d1j_1.atomicfu$get(index & $this.a1j_1).kotlinx$atomicfu$value;
  var tmp;
  if (old instanceof Placeholder()) {
    tmp = old.u1j_1 === index;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.d1j_1.atomicfu$get(index & $this.a1j_1).kotlinx$atomicfu$value = element;
    return $this;
  }
  return null;
}
function removeSlowPath($this, oldHead, newHead) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.c1j_1;
  while (true) {
    var state = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
    Companion_getInstance();
    var head = convertToInt(shiftRight(state & 1073741823n, 0));
    var tail = convertToInt(shiftRight(state & 1152921503533105152n, 30));
    // Inline function 'kotlinx.coroutines.assert' call
    if (!((state & 1152921504606846976n) === 0n)) {
      return $this.w1();
    }
    if ($this.c1j_1.atomicfu$compareAndSet(state, Companion_getInstance().v1j(state, newHead))) {
      $this.d1j_1.atomicfu$get(head & $this.a1j_1).kotlinx$atomicfu$value = null;
      return null;
    }
  }
}
function markFrozen($this) {
  var tmp0 = $this.c1j_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.updateAndGet' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      if (!((cur & 1152921504606846976n) === 0n))
        return cur;
      var upd = cur | 1152921504606846976n;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$1 = upd;
        break $l$block;
      }
    }
  }
  return tmp$ret$1;
}
function allocateOrGetNextCopy($this, state) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.b1j_1;
  while (true) {
    var next = this_0.kotlinx$atomicfu$value;
    if (!(next == null))
      return next;
    $this.b1j_1.atomicfu$compareAndSet(null, allocateNextCopy($this, state));
  }
}
function allocateNextCopy($this, state) {
  var next = new (LockFreeTaskQueueCore())(imul($this.y1i_1, 2), $this.z1i_1);
  // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
  Companion_getInstance();
  var head = convertToInt(shiftRight(state & 1073741823n, 0));
  var tail = convertToInt(shiftRight(state & 1152921503533105152n, 30));
  var index = head;
  while (!((index & $this.a1j_1) === (tail & $this.a1j_1))) {
    var tmp0_elvis_lhs = $this.d1j_1.atomicfu$get(index & $this.a1j_1).kotlinx$atomicfu$value;
    var value = tmp0_elvis_lhs == null ? new (Placeholder())(index) : tmp0_elvis_lhs;
    next.d1j_1.atomicfu$get(index & next.a1j_1).kotlinx$atomicfu$value = value;
    index = index + 1 | 0;
  }
  next.c1j_1.kotlinx$atomicfu$value = Companion_getInstance().w1j(state, 1152921504606846976n);
  return next;
}
var PlaceholderClass;
function Placeholder() {
  if (PlaceholderClass === VOID) {
    class $ {
      constructor(index) {
        this.u1j_1 = index;
      }
    }
    initMetadataForClass($, 'Placeholder');
    PlaceholderClass = $;
  }
  return PlaceholderClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.e1j_1 = 8;
        this.f1j_1 = 30;
        this.g1j_1 = 1073741823;
        this.h1j_1 = 0;
        this.i1j_1 = 1073741823n;
        this.j1j_1 = 30;
        this.k1j_1 = 1152921503533105152n;
        this.l1j_1 = 60;
        this.m1j_1 = 1152921504606846976n;
        this.n1j_1 = 61;
        this.o1j_1 = 2305843009213693952n;
        this.p1j_1 = 1024;
        this.q1j_1 = new (Symbol())('REMOVE_FROZEN');
        this.r1j_1 = 0;
        this.s1j_1 = 1;
        this.t1j_1 = 2;
      }
      w1j(_this__u8e3s4, other) {
        return _this__u8e3s4 & ~other;
      }
      v1j(_this__u8e3s4, newHead) {
        return this.w1j(_this__u8e3s4, 1073741823n) | shiftLeft(fromInt(newHead), 0);
      }
      x1j(_this__u8e3s4, newTail) {
        return this.w1j(_this__u8e3s4, 1152921503533105152n) | shiftLeft(fromInt(newTail), 30);
      }
      y1j(_this__u8e3s4) {
        return !((_this__u8e3s4 & 2305843009213693952n) === 0n) ? 2 : 1;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var LockFreeTaskQueueCoreClass;
function LockFreeTaskQueueCore() {
  if (LockFreeTaskQueueCoreClass === VOID) {
    class $ {
      constructor(capacity, singleConsumer) {
        Companion_getInstance();
        this.y1i_1 = capacity;
        this.z1i_1 = singleConsumer;
        this.a1j_1 = this.y1i_1 - 1 | 0;
        this.b1j_1 = atomic$ref$1(null);
        this.c1j_1 = atomic$long$1(0n);
        this.d1j_1 = atomicfu$AtomicRefArray$ofNulls(this.y1i_1);
        // Inline function 'kotlin.check' call
        if (!(this.a1j_1 <= 1073741823)) {
          throw IllegalStateException().o('Check failed.');
        }
        // Inline function 'kotlin.check' call
        if (!((this.y1i_1 & this.a1j_1) === 0)) {
          throw IllegalStateException().o('Check failed.');
        }
      }
      v2() {
        Companion_getInstance();
        // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
        var this_0 = this.c1j_1.kotlinx$atomicfu$value;
        var head = convertToInt(shiftRight(this_0 & 1073741823n, 0));
        var tail = convertToInt(shiftRight(this_0 & 1152921503533105152n, 30));
        return (tail - head | 0) & 1073741823;
      }
      x1i(element) {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.c1j_1;
        while (true) {
          var tmp0 = this_0.kotlinx$atomicfu$value;
          $l$block: {
            if (!((tmp0 & 3458764513820540928n) === 0n))
              return Companion_getInstance().y1j(tmp0);
            // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
            Companion_getInstance();
            var head = convertToInt(shiftRight(tmp0 & 1073741823n, 0));
            var tail = convertToInt(shiftRight(tmp0 & 1152921503533105152n, 30));
            var mask = this.a1j_1;
            if (((tail + 2 | 0) & mask) === (head & mask))
              return 1;
            if (!this.z1i_1 && !(this.d1j_1.atomicfu$get(tail & mask).kotlinx$atomicfu$value == null)) {
              if (this.y1i_1 < 1024 || ((tail - head | 0) & 1073741823) > this.y1i_1 >> 1) {
                return 1;
              }
              break $l$block;
            }
            var newTail = (tail + 1 | 0) & 1073741823;
            if (this.c1j_1.atomicfu$compareAndSet(tmp0, Companion_getInstance().x1j(tmp0, newTail))) {
              this.d1j_1.atomicfu$get(tail & mask).kotlinx$atomicfu$value = element;
              var cur = this;
              $l$loop_0: while ((cur.c1j_1.kotlinx$atomicfu$value & 1152921504606846976n) !== 0n) {
                var tmp0_elvis_lhs = fillPlaceholder(cur.w1(), tail, element);
                var tmp;
                if (tmp0_elvis_lhs == null) {
                  break $l$loop_0;
                } else {
                  tmp = tmp0_elvis_lhs;
                }
                cur = tmp;
              }
              return 0;
            }
          }
        }
      }
      yj() {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.c1j_1;
        while (true) {
          var tmp0 = this_0.kotlinx$atomicfu$value;
          $l$block_0: {
            if (!((tmp0 & 1152921504606846976n) === 0n))
              return Companion_getInstance().q1j_1;
            // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
            Companion_getInstance();
            var head = convertToInt(shiftRight(tmp0 & 1073741823n, 0));
            var tail = convertToInt(shiftRight(tmp0 & 1152921503533105152n, 30));
            if ((tail & this.a1j_1) === (head & this.a1j_1))
              return null;
            var element = this.d1j_1.atomicfu$get(head & this.a1j_1).kotlinx$atomicfu$value;
            if (element == null) {
              if (this.z1i_1)
                return null;
              break $l$block_0;
            }
            if (element instanceof Placeholder())
              return null;
            var newHead = (head + 1 | 0) & 1073741823;
            if (this.c1j_1.atomicfu$compareAndSet(tmp0, Companion_getInstance().v1j(tmp0, newHead))) {
              this.d1j_1.atomicfu$get(head & this.a1j_1).kotlinx$atomicfu$value = null;
              return element;
            }
            if (!this.z1i_1) {
              break $l$block_0;
            }
            var cur = this;
            while (true) {
              var tmp0_elvis_lhs = removeSlowPath(cur, head, newHead);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                return element;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              cur = tmp;
            }
          }
        }
      }
      w1() {
        return allocateOrGetNextCopy(this, markFrozen(this));
      }
    }
    initMetadataForClass($, 'LockFreeTaskQueueCore');
    LockFreeTaskQueueCoreClass = $;
  }
  return LockFreeTaskQueueCoreClass;
}
//region block: exports
export {
  LockFreeTaskQueue as LockFreeTaskQueue36fqk9kdm4om8,
};
//endregion

//# sourceMappingURL=LockFreeTaskQueue.mjs.map
